export default __webpack_public_path__ + "static/media/frontini-logo.4a7950c3.svg";